module.exports = __webpack_public_path__ + "img/bs-logo.5ca58009.png";